import {css} from '@yandex-delivery/blocks/theme/css'
import {cssTheme} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const box = css`
  z-index: 36;
  margin-block-end: ${spacing(1)};
`

export const header = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${cssTheme.default.day.everWhite};
  margin: ${spacing(1, 2)};
  padding: ${spacing(2)};
  border-radius: ${spacing(4)};
`
